<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>
              <BTab :title="$t('newDocumentDoc')">
                <AddAccountingDoc/>
              </BTab>
              <BTab :title="$t('sidebars.listDocuments')">
                <AccountingDocList/>
              </BTab>
              <BTab :title="$t('sidebars.journal')">
                <AccountingJournal/>
              </BTab>
<!--              <BTab :title="$t('InventoryAdjustment')">-->
<!--                <InventoryAdjustment/>-->
<!--              </BTab>-->
              <BTab :title="$t('DataEntry')">
                <JournalDataEntry/>
              </BTab>



            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import AccountingJournal from "./AccountingJournal";
var items = [];
import BTabs from "../../tabs/BTabs";

import AddAccountingDoc from './AddAccountingDoc';
import AccountingDocList from './AccountingDocList';
import InventoryAdjustment from "../inventoryAdjustment/InventoryAdjustment";
import BTab from "../../tabs/BTab";
import JournalDataEntry from "./JournalDataEntry";
import VATReport from "./VATReport.vue";
export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,

      AddAccountingDoc,
      AccountingDocList,
    AccountingJournal,
    InventoryAdjustment,
    JournalDataEntry,
    VATReport
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {

  }
}

</script>
